/**
 * 業種カテゴリー
 */
export const IndustryCategoryParentCode = {
  FISHERY_AGRICULTURE: 'fishery_agriculture',
  MINING: 'mining',
  CONSTRUCTION: 'construction',
  MANUFACTURING: 'manufacturing',
  ELECTRICITY_GAS: 'electricity_gas',
  TRANSPORTATION: 'transportation',
  INFORMATION_COMMUNICATION: 'information_communication',
  COMMERCE: 'commerce',
  FINANCE_INSURANCE: 'finance_insurance',
  REAL_ESTATE: 'real_estate',
  FOOD_ACCOMMODATION: 'food_accommodation',
  MEDICAL_WELFARE: 'medical_welfare',
  EDUCATION: 'education',
  SERVICE: 'service',
  GOVERNMENT: 'government',
  ORGANIZATION: 'organization',
  SPORTS: 'sports',
  COUNTRY: 'country',
  WORLD: 'world',
} as const

export const IndustryCategoryParentLabel: { [key: string]: string } = {
  [IndustryCategoryParentCode.FISHERY_AGRICULTURE]: '水産・農林業',
  [IndustryCategoryParentCode.MINING]: '鉱業',
  [IndustryCategoryParentCode.CONSTRUCTION]: '建設業',
  [IndustryCategoryParentCode.MANUFACTURING]: '製造業',
  [IndustryCategoryParentCode.ELECTRICITY_GAS]: '電気・ガス業・水道業',
  [IndustryCategoryParentCode.TRANSPORTATION]: '倉庫・運輸関連業',
  [IndustryCategoryParentCode.INFORMATION_COMMUNICATION]: '情報通信',
  [IndustryCategoryParentCode.COMMERCE]: '商業（卸売業、小売業）',
  [IndustryCategoryParentCode.FINANCE_INSURANCE]: '金融・保険業',
  [IndustryCategoryParentCode.REAL_ESTATE]: '不動産業',
  [IndustryCategoryParentCode.FOOD_ACCOMMODATION]: '飲食店・宿泊業',
  [IndustryCategoryParentCode.MEDICAL_WELFARE]: '医療・福祉',
  [IndustryCategoryParentCode.EDUCATION]: '教育・学習支援業',
  [IndustryCategoryParentCode.SERVICE]: 'サービス業',
  [IndustryCategoryParentCode.GOVERNMENT]: '官公庁・地方自治体',
  [IndustryCategoryParentCode.ORGANIZATION]: '財団法人・社団法人・宗教法人・団体',
  [IndustryCategoryParentCode.SPORTS]: 'スポーツ',
  [IndustryCategoryParentCode.COUNTRY]: '国',
  [IndustryCategoryParentCode.WORLD]: '世界',
}

export const IndustryCategoryParentValues = Object.entries(IndustryCategoryParentLabel).map(([code, value]) => ({
  code,
  value,
}))

/**
 * 業種子カテゴリー
 */
export const IndustryCategoryChildCode = {
  // 水産・農林業
  AGRICULTURE: 'agriculture',
  FORESTRY: 'forestry',
  FISHERIES: 'fisheries',
  // 鉱業
  MINING_AND_QUARRYING: 'mining_and_quarrying',
  // 建設業
  CONSTRUCTION: 'construction',
  CONSTRUCTION_CONSULTING: 'construction_consulting',
  PLANT_ENGINEERING: 'plant_engineering',
  // 製造業
  FOOD_PRODUCTS: 'food_products',
  TEXTILES: 'textiles',
  PULP_AND_PAPER: 'pulp_and_paper',
  CHEMICALS: 'chemicals',
  PHARMACEUTICALS: 'pharmaceuticals',
  RUBBER_PRODUCTS: 'rubber_products',
  STEEL: 'steel',
  NON_FERROUS_METALS: 'non_ferrous_metals',
  METAL_PRODUCTS: 'metal_products',
  MACHINERY: 'machinery',
  ELECTRICAL_EQUIPMENT: 'electrical_equipment',
  TRANSPORTATION_EQUIPMENT: 'transportation_equipment',
  PRECISION_INSTRUMENTS: 'precision_instruments',
  GLASS_AND_CERAMIC_PRODUCTS: 'glass_and_ceramic_products',
  PETROLEUM_AND_COAL_PRODUCTS: 'petroleum_and_coal_products',
  OTHER_PRODUCTS: 'other_products',
  // 電気・ガス業・水道業
  ELECTRICITY: 'electricity',
  GAS: 'gas',
  HEAT_SUPPLY: 'heat_supply',
  WATER_SUPPLY: 'water_supply',
  // 倉庫・運輸関連業
  RAILWAY_SERVICES: 'railway_services',
  ROAD_PASSENGER_TRANSPORT: 'road_passenger_transport',
  ROAD_FREIGHT_TRANSPORT: 'road_freight_transport',
  WATER_TRANSPORT: 'water_transport',
  AIR_TRANSPORT: 'air_transport',
  WAREHOUSING: 'warehousing',
  TRANSPORTATION_SUPPORT_SERVICES: 'transportation_support_services',
  POSTAL_SERVICES: 'postal_services',
  // 情報通信
  INFORMATION_SERVICES: 'information_services',
  TELECOMMUNICATIONS: 'telecommunications',
  BROADCASTING: 'broadcasting',
  GAMING: 'gaming',
  SYSTEM_INTEGRATORS: 'system_integrators',
  DATA_CENTERS: 'data_centers',
  // 商業
  WHOLESALE: 'wholesale',
  DEPARTMENT_STORES: 'department_stores',
  SUPERMARKETS: 'supermarkets',
  HOME_CENTERS: 'home_centers',
  CONSUMER_ELECTRONICS: 'consumer_electronics',
  FASHION_AND_APPAREL: 'fashion_and_apparel',
  AUTOMOTIVE_AND_TRANSPORTATION: 'automotive_and_transportation',
  MUSIC_BOOKS_AND_INTERIOR_GOODS: 'music_books_and_interior_goods',
  DRUGSTORES: 'drugstores',
  OPTICAL_GOODS: 'optical_goods',
  SPORTING_GOODS: 'sporting_goods',
  ENERGY: 'energy',
  CONSUMER_COOPERATIVES: 'consumer_cooperatives',
  ELECTRONICS_AND_SEMICONDUCTORS: 'electronics_and_semiconductors',
  SECOND_HAND_AND_REUSE: 'second_hand_and_reuse',
  OTHER_RETAIL_AND_DISTRIBUTION: 'other_retail_and_distribution',
  // 金融・保険業
  INVESTMENT_FUNDS_AND_RELATED_SERVICES: 'investment_funds_and_related_services',
  SECURITIES_AND_FUTURES: 'securities_and_futures',
  BANKS: 'banks',
  CREDIT_UNIONS: 'credit_unions',
  CREDIT_ASSOCIATIONS: 'credit_associations',
  AGRICULTURAL_FINANCE: 'agricultural_finance',
  INSURANCE: 'insurance',
  CREDIT_AND_FINANCING: 'credit_and_financing',
  MERGERS_AND_ACQUISITIONS: 'mergers_and_acquisitions',
  OTHER_FINANCIAL_SERVICES: 'other_financial_services',
  // 不動産業
  REAL_ESTATE_TRANSACTIONS: 'real_estate_transactions',
  REAL_ESTATE_LEASING_AND_MANAGEMENT: 'real_estate_leasing_and_management',
  GOODS_LEASING: 'goods_leasing',
  // 飲食店・宿泊業
  ACCOMMODATION_SERVICES: 'accommodation_services',
  RESTAURANTS: 'restaurants',
  TAKEAWAY_AND_DELIVERY: 'takeaway_and_delivery',
  // 医療・福祉
  MEDICAL_SERVICES: 'medical_services',
  PUBLIC_HEALTH: 'public_health',
  SOCIAL_INSURANCE_AND_WELFARE: 'social_insurance_and_welfare',
  // 教育・学習支援業
  UNIVERSITIES: 'universities',
  VOCATIONAL_SCHOOLS: 'vocational_schools',
  EDUCATION_AND_TRAINING_SERVICES: 'education_and_training_services',
  SCHOOL_EDUCATION: 'school_education',
  LEARNING_SUPPORT: 'learning_support',
  ACADEMIC_AND_RESEARCH_INSTITUTIONS: 'academic_and_research_institutions',
  // サービス業
  ADVERTISING_AND_MARKETING: 'advertising_and_marketing',
  PUBLISHING_AND_PRINTING: 'publishing_and_printing',
  ART_ILLUSTRATION_AND_PHOTOGRAPHY: 'art_illustration_and_photography',
  ENTERTAINMENT: 'entertainment',
  REAL_ESTATE_SERVICES: 'real_estate_services',
  CONSTRUCTION_SERVICES: 'construction_services',
  STAFFING_SERVICES: 'staffing_services',
  TRAVEL: 'travel',
  LEISURE_AND_AMUSEMENT: 'leisure_and_amusement',
  FITNESS_AND_SPAS: 'fitness_and_spas',
  BEAUTY_AND_RELAXATION: 'beauty_and_relaxation',
  CLEANING_AND_MAINTENANCE: 'cleaning_and_maintenance',
  CEREMONIAL_SERVICES: 'ceremonial_services',
  SECURITY: 'security',
  AUTOMOBILE_AND_MACHINERY_REPAIR: 'automobile_and_machinery_repair',
  CALL_CENTERS: 'call_centers',
  GOODS_RENTAL: 'goods_rental',
  ENVIRONMENTAL_SERVICES: 'environmental_services',
  RESEARCH_AND_CONSULTING: 'research_and_consulting',
  VIDEO_MUSICS: 'video_musics',
  NEWS_SERVICES: 'news_services',
  REGIONAL_REVITALIZATION: 'regional_revitalization',
  IT_SERVICES: 'it_services',
  OTHER_SERVICES: 'other_services',
  // 官公庁・地方自治体
  PREFECTURES: 'prefectures',
  MUNICIPALITIES: 'municipalities',
  SPECIAL_WARDS: 'special_wards',
  ADMINISTRATIVE_ORGANIZATIONS: 'administrative_organizations',
  // 財団法人・社団法人・宗教法人・団体
  POLITICAL_PARTIES: 'political_parties',
  INDEPENDENT_ADMINISTRATIVE_AGENCIES: 'independent_administrative_agencies',
  NPOS_AND_NGOS: 'npos_and_ngos',
  CITIZEN_GROUPS: 'citizen_groups',
  ASSOCIATIONS_AND_UNIONS: 'associations_and_unions',
  COOPERATIVES: 'cooperatives',
  // スポーツ
  BASEBALL: 'baseball',
  SOCCER_FOOTBALL: 'soccer_football',
  RUGBY: 'rugby',
  BASKETBALL: 'basketball',
  VOLLEYBALL: 'volleyball',
  TABLE_TENNIS: 'table_tennis',
  ICE_HOCKEY: 'ice_hockey',
  CURLING: 'curling',
  AMERICAN_FOOTBALL: 'american_football',
  SUMO_WRESTLING: 'sumo_wrestling',
  HORSE_RACING: 'horse_racing',
  // 国
  ASIA: 'asia',
  MIDDLE_EAST: 'middle_east',
  NORTH_AMERICA: 'north_america',
  CENTRAL_AND_SOUTH_AMERICA: 'central_and_south_america',
  EUROPE: 'europe',
  OCEANIA: 'oceania',
  AFRICA: 'africa',
  // 世界
  UNITED_NATIONS_AGENCIES: 'united_nations_agencies',
  SPORTS: 'sports',
} as const

export const IndustryCategoryChildLabel: { [key: string]: string } = {
  // 水産・農林業
  [IndustryCategoryChildCode.AGRICULTURE]: '農業',
  [IndustryCategoryChildCode.FORESTRY]: '林業',
  [IndustryCategoryChildCode.FISHERIES]: '水産業',
  // 鉱業
  [IndustryCategoryChildCode.MINING_AND_QUARRYING]: '鉱業・採石業・砂利採取業',
  // 建設業
  [IndustryCategoryChildCode.CONSTRUCTION]: '建設',
  [IndustryCategoryChildCode.CONSTRUCTION_CONSULTING]: '建設コンサルタント',
  [IndustryCategoryChildCode.PLANT_ENGINEERING]: 'プラント',
  // 製造業
  [IndustryCategoryChildCode.FOOD_PRODUCTS]: '食料品',
  [IndustryCategoryChildCode.TEXTILES]: '繊維製品',
  [IndustryCategoryChildCode.PULP_AND_PAPER]: 'パルプ・紙',
  [IndustryCategoryChildCode.CHEMICALS]: '化学',
  [IndustryCategoryChildCode.PHARMACEUTICALS]: '医薬品',
  [IndustryCategoryChildCode.RUBBER_PRODUCTS]: 'ゴム製品',
  [IndustryCategoryChildCode.STEEL]: '鉄鋼',
  [IndustryCategoryChildCode.NON_FERROUS_METALS]: '非鉄金属',
  [IndustryCategoryChildCode.METAL_PRODUCTS]: '金属製品',
  [IndustryCategoryChildCode.MACHINERY]: '機械',
  [IndustryCategoryChildCode.ELECTRICAL_EQUIPMENT]: '電気機器',
  [IndustryCategoryChildCode.TRANSPORTATION_EQUIPMENT]: '輸送用機器',
  [IndustryCategoryChildCode.PRECISION_INSTRUMENTS]: '精密機器',
  [IndustryCategoryChildCode.GLASS_AND_CERAMIC_PRODUCTS]: 'ガラス・土石製品',
  [IndustryCategoryChildCode.PETROLEUM_AND_COAL_PRODUCTS]: '石油・石炭製品',
  [IndustryCategoryChildCode.OTHER_PRODUCTS]: 'その他製品',
  // 電気・ガス業・水道業
  [IndustryCategoryChildCode.ELECTRICITY]: '電気業',
  [IndustryCategoryChildCode.GAS]: 'ガス業',
  [IndustryCategoryChildCode.HEAT_SUPPLY]: '熱供給業',
  [IndustryCategoryChildCode.WATER_SUPPLY]: '水道業',
  // 倉庫・運輸関連業
  [IndustryCategoryChildCode.RAILWAY_SERVICES]: '鉄道業',
  [IndustryCategoryChildCode.ROAD_PASSENGER_TRANSPORT]: '道路旅客運送業',
  [IndustryCategoryChildCode.ROAD_FREIGHT_TRANSPORT]: '道路貨物運送業',
  [IndustryCategoryChildCode.WATER_TRANSPORT]: '水運業',
  [IndustryCategoryChildCode.AIR_TRANSPORT]: '航空運輸業',
  [IndustryCategoryChildCode.WAREHOUSING]: '倉庫業',
  [IndustryCategoryChildCode.TRANSPORTATION_SUPPORT_SERVICES]: '運輸業',
  [IndustryCategoryChildCode.POSTAL_SERVICES]: '郵便業',
  // 情報通信
  [IndustryCategoryChildCode.INFORMATION_SERVICES]: '情報サービス業',
  [IndustryCategoryChildCode.TELECOMMUNICATIONS]: '通信業',
  [IndustryCategoryChildCode.BROADCASTING]: '放送業',
  [IndustryCategoryChildCode.GAMING]: 'ゲーム',
  [IndustryCategoryChildCode.SYSTEM_INTEGRATORS]: 'SIer・ソフトウェア開発・システム運用',
  [IndustryCategoryChildCode.DATA_CENTERS]: 'データセンター',
  // 商業
  [IndustryCategoryChildCode.WHOLESALE]: '卸売業',
  [IndustryCategoryChildCode.DEPARTMENT_STORES]: '百貨店・デパート・複合商業施設',
  [IndustryCategoryChildCode.SUPERMARKETS]: 'スーパー・コンビニエンスストア',
  [IndustryCategoryChildCode.HOME_CENTERS]: 'ホームセンター',
  [IndustryCategoryChildCode.CONSUMER_ELECTRONICS]: '家電',
  [IndustryCategoryChildCode.FASHION_AND_APPAREL]: 'ファッション・服飾雑貨・繊維',
  [IndustryCategoryChildCode.AUTOMOTIVE_AND_TRANSPORTATION]: '自動車・輸送機器',
  [IndustryCategoryChildCode.MUSIC_BOOKS_AND_INTERIOR_GOODS]: '音楽・書籍・インテリア',
  [IndustryCategoryChildCode.DRUGSTORES]: 'ドラッグストア・医薬品・化粧品・調剤薬局',
  [IndustryCategoryChildCode.OPTICAL_GOODS]: 'メガネ・コンタクト・医療機器',
  [IndustryCategoryChildCode.SPORTING_GOODS]: 'スポーツ用品',
  [IndustryCategoryChildCode.ENERGY]: '電力・ガス・水道・エネルギー',
  [IndustryCategoryChildCode.CONSUMER_COOPERATIVES]: '生活協同組合',
  [IndustryCategoryChildCode.ELECTRONICS_AND_SEMICONDUCTORS]: '電機・電子・半導体',
  [IndustryCategoryChildCode.SECOND_HAND_AND_REUSE]: '古物商・リユース',
  [IndustryCategoryChildCode.OTHER_RETAIL_AND_DISTRIBUTION]: 'その他流通・小売',
  // 金融・保険業
  [IndustryCategoryChildCode.INVESTMENT_FUNDS_AND_RELATED_SERVICES]: '投資ファンド・投資関連',
  [IndustryCategoryChildCode.SECURITIES_AND_FUTURES]: '証券・商品先物',
  [IndustryCategoryChildCode.BANKS]: '銀行',
  [IndustryCategoryChildCode.CREDIT_UNIONS]: '信用組合',
  [IndustryCategoryChildCode.CREDIT_ASSOCIATIONS]: '信用金庫',
  [IndustryCategoryChildCode.AGRICULTURAL_FINANCE]: '農林水産金融',
  [IndustryCategoryChildCode.INSURANCE]: '保険',
  [IndustryCategoryChildCode.CREDIT_AND_FINANCING]: 'クレジット・信販',
  [IndustryCategoryChildCode.MERGERS_AND_ACQUISITIONS]: 'M&A',
  [IndustryCategoryChildCode.OTHER_FINANCIAL_SERVICES]: 'その他金融・保険',
  // 不動産業
  [IndustryCategoryChildCode.REAL_ESTATE_TRANSACTIONS]: '不動産取引業',
  [IndustryCategoryChildCode.REAL_ESTATE_LEASING_AND_MANAGEMENT]: '不動産賃貸業・管理業',
  [IndustryCategoryChildCode.GOODS_LEASING]: '物品賃貸業',
  // 飲食店・宿泊業
  [IndustryCategoryChildCode.ACCOMMODATION_SERVICES]: '宿泊業',
  [IndustryCategoryChildCode.RESTAURANTS]: '飲食店',
  [IndustryCategoryChildCode.TAKEAWAY_AND_DELIVERY]: '持ち帰り・配達飲食サービス業',
  // 医療・福祉
  [IndustryCategoryChildCode.MEDICAL_SERVICES]: '医療業',
  [IndustryCategoryChildCode.PUBLIC_HEALTH]: '保健衛生',
  [IndustryCategoryChildCode.SOCIAL_INSURANCE_AND_WELFARE]: '社会保険・社会福祉・介護事業',
  // 教育・学習支援業
  [IndustryCategoryChildCode.UNIVERSITIES]: '大学',
  [IndustryCategoryChildCode.VOCATIONAL_SCHOOLS]: '専修学校',
  [IndustryCategoryChildCode.EDUCATION_AND_TRAINING_SERVICES]: '教育・研修サービス',
  [IndustryCategoryChildCode.SCHOOL_EDUCATION]: '学校教育',
  [IndustryCategoryChildCode.LEARNING_SUPPORT]: '学習支援',
  [IndustryCategoryChildCode.ACADEMIC_AND_RESEARCH_INSTITUTIONS]: '学術・開発研究機関',
  // サービス業
  [IndustryCategoryChildCode.ADVERTISING_AND_MARKETING]: '広告・マーケ・PR',
  [IndustryCategoryChildCode.PUBLISHING_AND_PRINTING]: '出版・印刷',
  [IndustryCategoryChildCode.ART_ILLUSTRATION_AND_PHOTOGRAPHY]: 'アート・イラスト・写真',
  [IndustryCategoryChildCode.ENTERTAINMENT]: '芸能・エンタメ',
  [IndustryCategoryChildCode.REAL_ESTATE_SERVICES]: '不動産サービス',
  [IndustryCategoryChildCode.CONSTRUCTION_SERVICES]: '建設サービス',
  [IndustryCategoryChildCode.STAFFING_SERVICES]: '人材サービス',
  [IndustryCategoryChildCode.TRAVEL]: '旅行',
  [IndustryCategoryChildCode.LEISURE_AND_AMUSEMENT]: 'レジャー・アミューズメント施設',
  [IndustryCategoryChildCode.FITNESS_AND_SPAS]: 'フィットネス・スパ・浴場',
  [IndustryCategoryChildCode.BEAUTY_AND_RELAXATION]: '美容・エステ・リラクゼーション',
  [IndustryCategoryChildCode.CLEANING_AND_MAINTENANCE]: 'クリーニング・メンテナンス',
  [IndustryCategoryChildCode.CEREMONIAL_SERVICES]: '冠婚葬祭',
  [IndustryCategoryChildCode.SECURITY]: '警備',
  [IndustryCategoryChildCode.AUTOMOBILE_AND_MACHINERY_REPAIR]: '自動車整備・機械等修理',
  [IndustryCategoryChildCode.CALL_CENTERS]: 'コールセンター・業務請負',
  [IndustryCategoryChildCode.GOODS_RENTAL]: '物品レンタル',
  [IndustryCategoryChildCode.ENVIRONMENTAL_SERVICES]: '環境サービス・廃棄物処理',
  [IndustryCategoryChildCode.RESEARCH_AND_CONSULTING]: 'リサーチ・コンサルティング',
  [IndustryCategoryChildCode.VIDEO_MUSICS]: '映像・音楽',
  [IndustryCategoryChildCode.NEWS_SERVICES]: '新聞・通信社',
  [IndustryCategoryChildCode.REGIONAL_REVITALIZATION]: '地方創生',
  [IndustryCategoryChildCode.IT_SERVICES]: 'ITサービス',
  [IndustryCategoryChildCode.OTHER_SERVICES]: 'その他サービス',
  // 官公庁・地方自治体
  [IndustryCategoryChildCode.PREFECTURES]: '都道府県',
  [IndustryCategoryChildCode.MUNICIPALITIES]: '市町村',
  [IndustryCategoryChildCode.SPECIAL_WARDS]: '特別区（23区）',
  [IndustryCategoryChildCode.ADMINISTRATIVE_ORGANIZATIONS]: '行政機関',
  // 財団法人・社団法人・宗教法人・団体
  [IndustryCategoryChildCode.POLITICAL_PARTIES]: '政党',
  [IndustryCategoryChildCode.INDEPENDENT_ADMINISTRATIVE_AGENCIES]: '独立行政・公益・社団・財団法人',
  [IndustryCategoryChildCode.NPOS_AND_NGOS]: 'NPO・NGO',
  [IndustryCategoryChildCode.CITIZEN_GROUPS]: '市民団体',
  [IndustryCategoryChildCode.ASSOCIATIONS_AND_UNIONS]: '協会・組合',
  [IndustryCategoryChildCode.COOPERATIVES]: '協同組合',
  // スポーツ
  [IndustryCategoryChildCode.BASEBALL]: '野球',
  [IndustryCategoryChildCode.SOCCER_FOOTBALL]: 'サッカー',
  [IndustryCategoryChildCode.RUGBY]: 'ラグビー',
  [IndustryCategoryChildCode.BASKETBALL]: 'バスケット',
  [IndustryCategoryChildCode.VOLLEYBALL]: 'バレーボール',
  [IndustryCategoryChildCode.TABLE_TENNIS]: '卓球',
  [IndustryCategoryChildCode.ICE_HOCKEY]: 'アイスホッケー',
  [IndustryCategoryChildCode.CURLING]: 'カーリング',
  [IndustryCategoryChildCode.AMERICAN_FOOTBALL]: 'アメリカンフットボール',
  [IndustryCategoryChildCode.SUMO_WRESTLING]: '相撲',
  [IndustryCategoryChildCode.HORSE_RACING]: '競馬',
  // 国
  [IndustryCategoryChildCode.ASIA]: 'アジア',
  [IndustryCategoryChildCode.MIDDLE_EAST]: '中東',
  [IndustryCategoryChildCode.NORTH_AMERICA]: '北米',
  [IndustryCategoryChildCode.CENTRAL_AND_SOUTH_AMERICA]: '中南米',
  [IndustryCategoryChildCode.EUROPE]: 'ヨーロッパ',
  [IndustryCategoryChildCode.OCEANIA]: 'オセアニア',
  [IndustryCategoryChildCode.AFRICA]: 'アフリカ',
  // 世界
  [IndustryCategoryChildCode.UNITED_NATIONS_AGENCIES]: '国連諸機関',
  [IndustryCategoryChildCode.SPORTS]: 'スポーツ',
}

export const IndustryCategoryChildValues = Object.entries(IndustryCategoryChildLabel).map(([code, value]) => ({
  code,
  value,
}))

// 親カテゴリーと子カテゴリーの関連付け
export const IndustryCategoryCodeRelations: { [key: string]: string[] } = {
  fishery_agriculture: [
    IndustryCategoryChildCode.AGRICULTURE,
    IndustryCategoryChildCode.FORESTRY,
    IndustryCategoryChildCode.FISHERIES,
  ],
  mining: [IndustryCategoryChildCode.MINING_AND_QUARRYING],
  construction: [
    IndustryCategoryChildCode.CONSTRUCTION,
    IndustryCategoryChildCode.CONSTRUCTION_CONSULTING,
    IndustryCategoryChildCode.PLANT_ENGINEERING,
  ],
  manufacturing: [
    IndustryCategoryChildCode.FOOD_PRODUCTS,
    IndustryCategoryChildCode.TEXTILES,
    IndustryCategoryChildCode.PULP_AND_PAPER,
    IndustryCategoryChildCode.CHEMICALS,
    IndustryCategoryChildCode.PHARMACEUTICALS,
    IndustryCategoryChildCode.RUBBER_PRODUCTS,
    IndustryCategoryChildCode.STEEL,
    IndustryCategoryChildCode.NON_FERROUS_METALS,
    IndustryCategoryChildCode.METAL_PRODUCTS,
    IndustryCategoryChildCode.MACHINERY,
    IndustryCategoryChildCode.ELECTRICAL_EQUIPMENT,
    IndustryCategoryChildCode.TRANSPORTATION_EQUIPMENT,
    IndustryCategoryChildCode.PRECISION_INSTRUMENTS,
    IndustryCategoryChildCode.GLASS_AND_CERAMIC_PRODUCTS,
    IndustryCategoryChildCode.PETROLEUM_AND_COAL_PRODUCTS,
    IndustryCategoryChildCode.OTHER_PRODUCTS,
  ],
  electricity_gas: [
    IndustryCategoryChildCode.ELECTRICITY,
    IndustryCategoryChildCode.GAS,
    IndustryCategoryChildCode.HEAT_SUPPLY,
    IndustryCategoryChildCode.WATER_SUPPLY,
  ],
  transportation: [
    IndustryCategoryChildCode.RAILWAY_SERVICES,
    IndustryCategoryChildCode.ROAD_PASSENGER_TRANSPORT,
    IndustryCategoryChildCode.ROAD_FREIGHT_TRANSPORT,
    IndustryCategoryChildCode.WATER_TRANSPORT,
    IndustryCategoryChildCode.AIR_TRANSPORT,
    IndustryCategoryChildCode.WAREHOUSING,
    IndustryCategoryChildCode.TRANSPORTATION_SUPPORT_SERVICES,
    IndustryCategoryChildCode.POSTAL_SERVICES,
  ],
  information_communication: [
    IndustryCategoryChildCode.INFORMATION_SERVICES,
    IndustryCategoryChildCode.TELECOMMUNICATIONS,
    IndustryCategoryChildCode.BROADCASTING,
    IndustryCategoryChildCode.GAMING,
    IndustryCategoryChildCode.SYSTEM_INTEGRATORS,
    IndustryCategoryChildCode.DATA_CENTERS,
  ],
  commerce: [
    IndustryCategoryChildCode.WHOLESALE,
    IndustryCategoryChildCode.DEPARTMENT_STORES,
    IndustryCategoryChildCode.SUPERMARKETS,
    IndustryCategoryChildCode.HOME_CENTERS,
    IndustryCategoryChildCode.CONSUMER_ELECTRONICS,
    IndustryCategoryChildCode.FASHION_AND_APPAREL,
    IndustryCategoryChildCode.AUTOMOTIVE_AND_TRANSPORTATION,
    IndustryCategoryChildCode.MUSIC_BOOKS_AND_INTERIOR_GOODS,
    IndustryCategoryChildCode.DRUGSTORES,
    IndustryCategoryChildCode.OPTICAL_GOODS,
    IndustryCategoryChildCode.SPORTING_GOODS,
    IndustryCategoryChildCode.ENERGY,
    IndustryCategoryChildCode.CONSUMER_COOPERATIVES,
    IndustryCategoryChildCode.ELECTRONICS_AND_SEMICONDUCTORS,
    IndustryCategoryChildCode.SECOND_HAND_AND_REUSE,
    IndustryCategoryChildCode.OTHER_RETAIL_AND_DISTRIBUTION,
  ],
  finance_insurance: [
    IndustryCategoryChildCode.INVESTMENT_FUNDS_AND_RELATED_SERVICES,
    IndustryCategoryChildCode.SECURITIES_AND_FUTURES,
    IndustryCategoryChildCode.BANKS,
    IndustryCategoryChildCode.CREDIT_UNIONS,
    IndustryCategoryChildCode.CREDIT_ASSOCIATIONS,
    IndustryCategoryChildCode.AGRICULTURAL_FINANCE,
    IndustryCategoryChildCode.INSURANCE,
    IndustryCategoryChildCode.CREDIT_AND_FINANCING,
    IndustryCategoryChildCode.MERGERS_AND_ACQUISITIONS,
    IndustryCategoryChildCode.OTHER_FINANCIAL_SERVICES,
  ],
  real_estate: [
    IndustryCategoryChildCode.REAL_ESTATE_TRANSACTIONS,
    IndustryCategoryChildCode.REAL_ESTATE_LEASING_AND_MANAGEMENT,
    IndustryCategoryChildCode.GOODS_LEASING,
  ],
  food_accommodation: [
    IndustryCategoryChildCode.ACCOMMODATION_SERVICES,
    IndustryCategoryChildCode.RESTAURANTS,
    IndustryCategoryChildCode.TAKEAWAY_AND_DELIVERY,
  ],
  medical_welfare: [
    IndustryCategoryChildCode.MEDICAL_SERVICES,
    IndustryCategoryChildCode.PUBLIC_HEALTH,
    IndustryCategoryChildCode.SOCIAL_INSURANCE_AND_WELFARE,
  ],
  education: [
    IndustryCategoryChildCode.UNIVERSITIES,
    IndustryCategoryChildCode.VOCATIONAL_SCHOOLS,
    IndustryCategoryChildCode.EDUCATION_AND_TRAINING_SERVICES,
    IndustryCategoryChildCode.SCHOOL_EDUCATION,
    IndustryCategoryChildCode.LEARNING_SUPPORT,
    IndustryCategoryChildCode.ACADEMIC_AND_RESEARCH_INSTITUTIONS,
  ],
  service: [
    IndustryCategoryChildCode.ADVERTISING_AND_MARKETING,
    IndustryCategoryChildCode.PUBLISHING_AND_PRINTING,
    IndustryCategoryChildCode.ART_ILLUSTRATION_AND_PHOTOGRAPHY,
    IndustryCategoryChildCode.ENTERTAINMENT,
    IndustryCategoryChildCode.REAL_ESTATE_SERVICES,
    IndustryCategoryChildCode.CONSTRUCTION_SERVICES,
    IndustryCategoryChildCode.STAFFING_SERVICES,
    IndustryCategoryChildCode.TRAVEL,
    IndustryCategoryChildCode.LEISURE_AND_AMUSEMENT,
    IndustryCategoryChildCode.FITNESS_AND_SPAS,
    IndustryCategoryChildCode.BEAUTY_AND_RELAXATION,
    IndustryCategoryChildCode.CLEANING_AND_MAINTENANCE,
    IndustryCategoryChildCode.CEREMONIAL_SERVICES,
    IndustryCategoryChildCode.SECURITY,
    IndustryCategoryChildCode.AUTOMOBILE_AND_MACHINERY_REPAIR,
    IndustryCategoryChildCode.CALL_CENTERS,
    IndustryCategoryChildCode.GOODS_RENTAL,
    IndustryCategoryChildCode.ENVIRONMENTAL_SERVICES,
    IndustryCategoryChildCode.RESEARCH_AND_CONSULTING,
    IndustryCategoryChildCode.VIDEO_MUSICS,
    IndustryCategoryChildCode.NEWS_SERVICES,
    IndustryCategoryChildCode.REGIONAL_REVITALIZATION,
    IndustryCategoryChildCode.IT_SERVICES,
    IndustryCategoryChildCode.OTHER_SERVICES,
  ],
  government: [
    IndustryCategoryChildCode.PREFECTURES,
    IndustryCategoryChildCode.MUNICIPALITIES,
    IndustryCategoryChildCode.SPECIAL_WARDS,
    IndustryCategoryChildCode.ADMINISTRATIVE_ORGANIZATIONS,
  ],
  organization: [
    IndustryCategoryChildCode.POLITICAL_PARTIES,
    IndustryCategoryChildCode.INDEPENDENT_ADMINISTRATIVE_AGENCIES,
    IndustryCategoryChildCode.NPOS_AND_NGOS,
    IndustryCategoryChildCode.CITIZEN_GROUPS,
    IndustryCategoryChildCode.ASSOCIATIONS_AND_UNIONS,
    IndustryCategoryChildCode.COOPERATIVES,
  ],
  sports: [
    IndustryCategoryChildCode.BASEBALL,
    IndustryCategoryChildCode.SOCCER_FOOTBALL,
    IndustryCategoryChildCode.RUGBY,
    IndustryCategoryChildCode.BASKETBALL,
    IndustryCategoryChildCode.VOLLEYBALL,
    IndustryCategoryChildCode.TABLE_TENNIS,
    IndustryCategoryChildCode.ICE_HOCKEY,
    IndustryCategoryChildCode.CURLING,
    IndustryCategoryChildCode.AMERICAN_FOOTBALL,
    IndustryCategoryChildCode.SUMO_WRESTLING,
    IndustryCategoryChildCode.HORSE_RACING,
  ],
  country: [
    IndustryCategoryChildCode.ASIA,
    IndustryCategoryChildCode.MIDDLE_EAST,
    IndustryCategoryChildCode.NORTH_AMERICA,
    IndustryCategoryChildCode.CENTRAL_AND_SOUTH_AMERICA,
    IndustryCategoryChildCode.EUROPE,
    IndustryCategoryChildCode.OCEANIA,
    IndustryCategoryChildCode.AFRICA,
  ],
  world: [
    IndustryCategoryChildCode.UNITED_NATIONS_AGENCIES,
    IndustryCategoryChildCode.SPORTS,
  ],
}
